import { render, staticRenderFns } from "./EditCallCenterAdminComponent.vue?vue&type=template&id=b5925d4c&"
import script from "./EditCallCenterAdminComponent.vue?vue&type=script&lang=js&"
export * from "./EditCallCenterAdminComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports